import * as React from 'react';
import getSelectedFolderViewState from '../selectors/getSelectedFolderViewState';
import selectTodoById from '../selectors/selectTodoById';
import TodoListItem from './TodoListItem';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { clearFocusTodoId } from '../actions/todoFolderViewStateActions';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { observer } from 'mobx-react';

const styles = require('./TodoList.scss');

export interface TodoListProps {
    todoIds: string[];

    /**
     * Whether this list supports items being dropped over it.
     * @default true
     */
    canDropOver?: boolean;
}

@observer
export default class TodoList extends React.Component<TodoListProps, {}> {
    static defaultProps = {
        canDropOver: true,
    };

    private taskItemRefs = {};

    componentDidUpdate() {
        /**
         * focusTodoId is set before a focused todo is removed from the view
         * (i.e. it is completed or deleted). Before the todo is removed the focusTodoId
         * is set to the Id o the todo which follows it in the list, or the todo before it
         * if it is the last todo in the list
         */
        let focusTodoId = getSelectedFolderViewState().focusTodoId;
        if (focusTodoId) {
            // TODO: if there are no more todos in the list t null be null and focus will be lost
            if (focusTodoId && this.taskItemRefs[focusTodoId]) {
                this.taskItemRefs[focusTodoId].setFocus();
                clearFocusTodoId();
            }
        }
    }

    render() {
        const ariaPropsGrid: AriaProperties = { role: AriaRoles.grid };

        return (
            <div className={styles.todos} {...generateDomPropertiesForAria(ariaPropsGrid)}>
                <FocusZone direction={FocusZoneDirection.vertical}>
                    {this.props.todoIds.map(todoId => {
                        const todo = selectTodoById(todoId);
                        return (
                            <TodoListItem
                                ref={ref => (this.taskItemRefs[todo.Id] = ref)}
                                key={todo.Id}
                                todo={todo}
                                canDropOver={this.props.canDropOver}
                            />
                        );
                    })}
                </FocusZone>
            </div>
        );
    }
}
